<template>
	<div class="opts_wrap" v-loading="loading">
		
		<div class="opts_line">
			<p class="txt">标题：</p>
			<div class="con">
				<el-input v-model="tag_title" @input="bindInput" clearable></el-input>
			</div>
		</div>
		<div class="opts_line">
			<p class="txt">选择打印机：</p>
			<div class="con">
				<el-select class="w100" v-model="printer_index" placeholder="请选择" @change="printerChange" clearable>
					<el-option v-for="item in printers" :key="item.index" :label="item.name" :value="item.index">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<el-progress style="width: 100%;" :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
			</div>
		</div>
		<div class="btn_wrap">
			<p class="btn" @click="saveBtn()">提交</p>
			<p class="btn" @click="cancel()">取消</p>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import { getLodop } from '@/assets/js/utils/LodopFuncs'
export default {
	name: "orderTags",
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		show: {
			type: Boolean,
			default: false
		},
		order_id: {
			type: Array,
			default: ()=>{
				return []
			}
		},
	},
	data() {
		return {
			percentage:0,
			loading: false,
			lodop:null,
			printer_index:'',
			printers:[],
			tag_title: '星好货供应链',
			page_data: {
				page: 1,
				page_size: 1
			},
		};
	},
	
	created(){
		this.initLodop()
		let tag_title = localStorage.getItem('tag_title')
		if(tag_title){
			this.tag_title = tag_title
		}
		
	},
	mounted() {
	},
	
	computed:{
		...mapState({
			
		}),
	},
	watch:{
		show(val) {
			if(val){
				this.percentage = 0
				this.initLodop()
				console.log(this.order_id)
			}
		}
	},
	
	methods: {
		...mapActions({
			opMakeOrderProductTags:"ucenter/opMakeOrderProductTags",
			getOrderTags:"ucenter/getOrderTags",
		}),
		bindInput(e){
			localStorage.setItem('tag_title',e)
		},
		//实例化打印组件
		initLodop(){
			console.log('initLodop')
			this.lodop = getLodop()
			this.check_lodop_install()
		},
		//检查lodop状态
		check_lodop_install(){
			var that = this
			var lodop = that.lodop
			if(!that.show){
				console.log(that.show)
				return false
			}
			if(lodop == undefined || lodop == null){
				setTimeout(function(){
					console.log(333)
					that.check_lodop_install()
				},1000)
			}else{
				if (lodop.VERSION) {
						 console.log(lodop.VERSION)
						 that.getPrinter()
					}
			}
		},
		//获取打印机列表
		getPrinter(){
			let lodop = this.lodop
			let printer_num = lodop.GET_PRINTER_COUNT()
			let printers = []
			for(var i=0;i < printer_num; i++){
					printers.push({index:i,name:lodop.GET_PRINTER_NAME(i)})
			}
			this.printers = printers
			let printer_index = localStorage.getItem('supplier_printer_index')
			if(printer_index != undefined && printer_index != null){
				this.printer_index = parseInt(printer_index)
			}
		},
		//选择打印机
		printerChange(e){
			this.lodop.SET_PRINTER_INDEX(e)
			localStorage.setItem('supplier_printer_index',parseInt(e))
		},
		cancel(){
			this.$emit('close', {})
		},
		saveBtn(){
			let that = this
			let param = {ids:this.order_id}//supplier_order_id
			console.log(param)
			that.percentage = 0
			that.page_data.page = 1
			that.$confirm('确认打印订单商品标签?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.opMakeOrderProductTags({data:param,success:(res)=>{
					if(res.code == 200){
						that.$message({
							type: 'success',
							message: res.msg
						})
						// this.$emit('success')
						// this.$emit('close')
						that.getPrintData(res.data)
					}else{
						that.$message({
							type: 'error',
							message: res.msg
						})
					}
				}})
			}).catch((res) => {
				console.log(res)
			});
		},
		
		//获取打印数据打印
		getPrintData(log_id){
			console.log(log_id)
			let that = this
			let page = this.page_data.page
			let params = {log_id:log_id,page:page,page_size:this.page_data.page_size}
			this.getOrderTags({data:params,success:(res)=>{
				console.log(res)
				if(res.code == 200){
					let total_page = res.data.last_page
					if(that.page_data.page == 1){
						that.lodop.PRINT_INIT('打印订单标签')
					}
					
					that.lodopAddData(res.data.data,res.data.bar_code_num,res.data.dd_order_id)
					if(page == total_page){
						that.percentage = 100;
						that.lodopPrint()
					}else{
						that.percentage = parseInt(page/total_page*100)
						that.getPrintData(log_id)
					}
				}else{
					that.$message({
						type: 'error',
						message: res.msg
					})
				}
			}})
		},
		//加入
		lodopAddData(htm,bar_code_num,dd_order_id){
			let lodop = this.lodop
			if(this.page_data.page != 1){
				lodop.NewPageA();
			}
			this.page_data.page ++
			lodop.SET_PRINT_PAGESIZE(2,"80mm","40mm" ,"CreateCustomPage")//1竖向 2横向
			// lodop.SET_PRINT_STYLE("FontSize",11);
			let tag_title_html = '<div style="width:100%;text-align:center;font-size:13px;">'+this.tag_title+'</div>'
			lodop.ADD_PRINT_HTM(10,0,"40mm","4mm",tag_title_html);//top,left,w,h,html
			lodop.ADD_PRINT_BARCODE(30,"9mm","22mm","22mm",'QRCode',bar_code_num);//Top,Left,Width,Height,BarCodeType,BarCodeValue
			lodop.SET_PRINT_STYLEA(0,"ShowBarText",0);//隐藏条码下方数值
			let id_html = '<div style="width:100%;text-align:center;font-size:10px;">'+bar_code_num+'</div>'
			lodop.ADD_PRINT_HTM(110,0,"40mm","4mm",id_html);//top,left,w,h,html
			// lodop.SET_PRINT_STYLEA(0,"FontSize",7);//设置条码数值字体大小
			lodop.ADD_PRINT_HTM(120, 0, '40mm', '45mm', htm) // 添加HTML模板内容1in = 2.54cm = 25.4mm = 72pt = 96px
			lodop.SET_PRINT_STYLEA(0,"DataCharset","UTF-8");
		},
		lodopPrint(){
			let lodop = this.lodop
			// lodop.PREVIEW() // 预览
			lodop.PRINT(); // 直接打印
			this.$emit('success')
		},
		// preview(htm){
		// 	const LODOP = getLodop()
		// 	LODOP.PRINT_INIT('打印订单进货单') // 打印初始化(打印任务名)
		// 	for(var i in htm){
		// 		if(i > 0){
		// 			LODOP.NewPageA();
		// 		}
		// 		LODOP.SET_PRINT_PAGESIZE(1,760,1300 ,"")//1竖向 2横向
		// 		LODOP.ADD_PRINT_HTM(3, 3, '100%', '100%', htm[i]) // 添加HTML模板内容
		// 	}
		// 	LODOP.PRINT(); // 直接打印
		// 	LODOP.PREVIEW() // 预览
		// },
	},

}
</script>

<style scoped>
	.opts_wrap{padding-top: 14px;}
	.opts_wrap .opts_line{display: flex;align-items: center;position: relative;margin-bottom: 30px;}
	.opts_line .txt{width: 110px;text-align: left;font-size: 14px;position: absolute;left: 14px;z-index: 1;color: #C0C4CC;pointer-events: none;}
	.opts_line .con{flex: 1;width: 0;margin-left: 0px;display: flex;align-items: center;}
	.opts_line .con .t{font-size: 14px;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.opts_wrap .btn_wrap .btn:nth-child(3){background: #fff;color: #333;border: 1px solid #ddd;}
	.w80{width: 80px;}
	.w100{width: 100%;}
	.s_line{padding:0 12px;height: 34px;line-height: 34px;border:1px solid #DCDFE6;border-radius:4px;width: 100%;}
	.s_line .label{color:#C0C4CC;font-size:14px;width: 68px;display:inline-block;}
	.s_line .info{display:inline-block;}
	
	/* .el-input{height: 34px;line-height: 34px;} */
	/deep/.el-input__prefix{height:34px;line-height:34px;margin-left:15px;left: 0 !important;}
	/deep/.el-input--suffix .el-input__inner{padding-left: 55px;}
	/deep/.el-select .el-input__inner{padding-left:110px;height:34px;line-height:34px;}
	/deep/.el-input--prefix .el-input__inner, .el-cascader .el-input .el-input__inner{padding-left:110px;height: 34px !important;}
</style>
